module.exports = __webpack_public_path__ + "static/testemonial2-642a868fd4f12c5b37fa24c5ff38d8aa.png";